import { Confirm } from './';

import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { omit } from 'lodash';

class ActionConfirm extends Component {
  state = { open: false };
  onOpen = () => this.setState({ open: true });
  onConfirm = () => {
    const { onConfirm } = this.props;
    onConfirm();
    this.setState({ open: false });
  };
  onCancel = () => this.setState({ open: false });
  render() {
    const props = omit(this.props, 'onOpen', 'onConfirm', 'onCancel');
    const { open } = this.state;
    return (
      <Confirm
        open={open}
        {...props}
        onOpen={this.onOpen}
        onConfirm={this.onConfirm}
        onCancel={this.onCancel}
        basic
      />
    );
  }
}

export default ActionConfirm;



// WEBPACK FOOTER //
// ./src/components/ActionConfirm.js